<template>
  <div class="interactive-pdf">
    <header-box :title="title"></header-box>
    <div class="interactive-pdf__innerwrap">
      <ul class="interactive-pdf__names">
        <li class="interactive-pdf__name" v-for="(pdf, index) in pdfFiles">
          <a @click="setPdfIndex(index)" v-html="pdf.title"></a>
        </li>
      </ul>
      <iframe class="interactive-pdf__pdf-iframe no-swipe-nav" :src="pdfIframe"></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';

export default {
  name: 'interactive-pdf',
  components: { PrevNextNav, HeaderBox },
  data() {
    return {
      index: 0,
    };
  },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    pdfFiles() {
      return this.page.pdfFiles;
    },
    pdfUrl() {
      if (this.page.pdfFiles[this.index].url.indexOf('static') === 0) {
        return `../../${this.page.pdfFiles[this.index].url}`;
      }
      return this.page.pdfFiles[this.index].url;
    },
    pdfIframe() {
      return `static/pdf-js-viewer/index.html?file=${this.pdfUrl}`;
    },
  },
  methods: {
    setPdfIndex(index) {
      this.index = index;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.interactive-pdf {
  @include page(true, true);

  &__innerwrap {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;

    @include not-mobile {
      padding-bottom: 40px;
      padding-top: 0;
    }

    @include landscape {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }

  &__names {
    display: none;

    @include not-mobile {
      @include font-block-title;
      color: $c_primary;
      display: block;
      list-style: none;
      padding: 0;
      margin: 30px 0 30px 8.333%;
      width: 91.666%;
    }

    @include landscape {
      display: none;
    }
  }

  &__name {
    display: inline-block;
    margin-left: 40px;

    &:first-child {
      margin-left: 25px;
    }

    &::after {
      display: inline-block;
      content: '';
      width: 16px;
      height: 16px;
      background: url('../../../static/svg/icon_table.svg') no-repeat center;
      margin-left: 10px;
      vertical-align: top;
    }

    a {
      color: inherit;
      text-decoration: none;
      cursor: pointer;
    }
  }

  &__pdf-iframe {
    width: 100%;
    display: block;
    background: $c_white;
    flex-grow: 1;
    border: 0;

    @include not-mobile {
      margin: 0 0 0 8.333%;
      width: 91.666%;
    }

    @include landscape {
      width: 100%;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/InteractivePdf.vue